import { Box } from '@mui/material';
import { FC } from 'react';
import NavigationRail from './NavigationRail';
import MainLayout from './MainLayout';

const MobileLayout: FC = () => {
    return (
        <Box
            sx={{
                height: '100vh',
                width: '100%',
            }}
        >
            <MainLayout />
            <NavigationRail />
        </Box>
    );
};

export default MobileLayout;
